import {
  WORKFLOW_MESSAGE_TYPE_EMAIL,
  WORKFLOW_MESSAGE_TYPE_SMS
} from 'Api/beAutomationApi'
import { atom, atomFamily, selector, selectorFamily } from 'recoil'
import { searchState } from './search'

export const workflowState = atom({
  key: 'workflowStatistics__workflowState',
  default: {
    name: undefined,
    steps: [],
    conditionsDescription: undefined,
    stepsHaveTriggered: {}
  }
})

export const dynamicFieldsState = atom({
  key: 'workflowStatistics__dynamicFieldsState',
  default: []
})

export const messageDetailsState = atomFamily({
  key: 'workflowStatistics__messageDetailsState',
  default: {
    subject: undefined,
    messageType: undefined,
    clicks: 0,
    viewOrDelivered: 0,
    send: 0,
    rec: 0,
    timeConditionId: 0,
    timeConditionDescription: 0,
    hasTriggered: false,
    loading: false,
    isFirst: false,
    recipientExecutionDate: undefined
  }
})

export const totalStatsState = atomFamily({
  key: 'workflowStatistics__totalStatsState',
  default: {
    ids: [],
    totalClicks: 0,
    totalViewOrDelivered: 0,
    totalSend: 0,
    totalRec: 0
  }
})

export const showCumulativeStatisticsState = selector({
  key: 'workflowStatistics__showCumulativeStatisticsState',
  get: ({ get }) => {
    const { ids: idsSms } = get(totalStatsState(WORKFLOW_MESSAGE_TYPE_SMS))
    const { ids: idsEmail } = get(totalStatsState(WORKFLOW_MESSAGE_TYPE_EMAIL))

    return [idsEmail.length > 0, idsSms.length > 0]
  }
})

export const startConditionsDatesState = atom({
  key: 'workflowStatistics__startConditionsDatesState',
  default: {
    firstExecutionDate: undefined,
    lastExecutionDate: undefined
  }
})

export const opacityConditionState = selectorFamily({
  key: 'workflowStatistics__opacityConditionState',
  get:
    (idMessage) =>
    ({ get }) => {
      if (idMessage) {
        const { clicks, viewOrDelivered, send, hasTriggered } = get(
          messageDetailsState(idMessage)
        )
        const { totalItems } = get(searchState)

        return (
          (totalItems >= 0 &&
            send === 0 &&
            viewOrDelivered === 0 &&
            clicks === 0) ||
          !hasTriggered
        )
      }
      return true
    }
})
